import { render, staticRenderFns } from "./familySocialRelation.vue?vue&type=template&id=1e65ce58"
import script from "./familySocialRelation.vue?vue&type=script&lang=js"
export * from "./familySocialRelation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports